var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"green","dark":""},on:{"click":_vm.onAddUserClick}},[_vm._v("Add User")]),_c('users-table'),_c('user-rules-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }